import { type PropType } from "vue";
import { UPDATE_MODEL_VALUE } from "../../constants";

export interface ModalProps {
    modelValue: boolean;
    type?: "window" | "left" | "right";
    maxWidth?: string;
    title?: string;
    titleTextAlign?: string;
    hideFooter?: boolean;
    hideFooterActions?: boolean;
    hideCancelButton?: boolean;
    hideApproveButton?: boolean;
    disabledApproveButton?: boolean;
    cancelText?: string;
    approveText?: string;
}

export const modalProps = {
    modelValue: {
        type: Boolean as PropType<ModalProps["modelValue"]>,
        default: undefined,
        required: true,
    },
    type: {
        type: String as PropType<ModalProps["type"]>,
        default: "window",
        required: false,
    },
    maxWidth: {
        type: String as PropType<ModalProps["maxWidth"]>,
        default: undefined,
        required: false,
    },
    title: {
        type: String as PropType<ModalProps["title"]>,
        default: undefined,
        required: false,
    },
    titleTextAlign: {
        type: String as PropType<ModalProps["titleTextAlign"]>,
        default: undefined,
        required: false,
    },
    hideFooter: {
        type: Boolean as PropType<ModalProps["hideFooter"]>,
        default: false,
        required: false,
    },
    hideFooterActions: {
        type: Boolean as PropType<ModalProps["hideFooterActions"]>,
        default: false,
        required: false,
    },
    hideCancelButton: {
        type: Boolean as PropType<ModalProps["hideCancelButton"]>,
        default: false,
        required: false,
    },
    hideApproveButton: {
        type: Boolean as PropType<ModalProps["hideApproveButton"]>,
        default: false,
        required: false,
    },
    disabledApproveButton: {
        type: Boolean as PropType<ModalProps["disabledApproveButton"]>,
        default: false,
        required: false,
    },
    cancelText: {
        type: String as PropType<ModalProps["cancelText"]>,
        default: "Отмена",
        required: false,
    },
    approveText: {
        type: String as PropType<ModalProps["approveText"]>,
        default: "Применить",
        required: false,
    },
};

export const modalEmits = {
    [UPDATE_MODEL_VALUE]: (event: boolean) => event,
    close: (event: boolean) => event,
    cancel: (event: boolean) => event,
    approve: (event: boolean) => event,
};
